<div class="cmp-view-root">
  <mat-form-field appearance="outline" class="inv-select-field" *ngIf="allInventory?.length; else loadingInv">
    <mat-label>Select Inventory</mat-label>
    <mat-select [(ngModel)]="selectedInventory" (selectionChange)="onInventoryChange($event.value)" panelClass="cc-select-panel">
      <mat-option *ngFor="let item of allInventory" [value]="item">
        {{ item.hostname }} — {{ item.hpnaGroup }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <ng-template #loadingInv>
    <div class="loading-inline">Loading inventory...</div>
  </ng-template>

  <div *ngIf="selectedInventory; else selectHint" class="section inventory-section">
    <div class="section-header">
      <h3 class="section-title">Inventory</h3>
      <div class="host-ref">{{ selectedInventory.hostname }}</div>
    </div>
    <div class="section-hint" *ngIf="inventoryLoading">Loading inventory differences…</div>
    <div class="section-hint" *ngIf="inventoryDiffCount && !inventoryExpanded && !inventoryLoading">
      Expand the Inventory card in the summary to highlight mismatched fields.
    </div>
    <div class="fields-grid">
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('hostname')">
        <div class="field-label">Hostname</div>
        <div class="field-value">{{ selectedInventory.hostname }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('serialNumber')">
        <div class="field-label">Serial Number</div>
        <div class="field-value">{{ selectedInventory.serialNumber }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('asaRole')">
        <div class="field-label">ASA Role</div>
        <div class="field-value">{{ selectedInventory.asaRole }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('asaVersion')">
        <div class="field-label">ASA Version</div>
        <div class="field-value">{{ selectedInventory.asaVersion }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('hardwareModel')">
        <div class="field-label">Hardware Model</div>
        <div class="field-value">{{ selectedInventory.hardwareModel }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('hpnaGroup')">
        <div class="field-label">HPNA Group</div>
        <div class="field-value">{{ selectedInventory.hpnaGroup }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('lastModified')">
        <div class="field-label">Last Modified</div>
        <div class="field-value">{{ selectedInventory.lastModified }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('mgmtIpAddress')">
        <div class="field-label">Mgmt IP Address</div>
        <div class="field-value">{{ selectedInventory.mgmtIpAddress }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('recordDateTime')">
        <div class="field-label">Record Date/Time</div>
        <div class="field-value">{{ selectedInventory.recordDateTime }}</div>
      </div>
      <div class="field" [class.diff]="inventoryHighlightKeys.includes('retrievedDate')">
        <div class="field-label">Retrieved Date</div>
        <div class="field-value">{{ selectedInventory.retrievedDate }}</div>
      </div>
    </div>
  </div>
  <ng-template #selectHint>
    <div class="placeholder small">
      <mat-icon>info</mat-icon>
      <p>Select an inventory record.</p>
    </div>
  </ng-template>

  <div *ngIf="selectedInventory" class="section interface-section">
    <div class="section-header">
      <h3 class="section-title">Interfaces</h3>
      <div class="count-pill" [class.has-diff]="getInterfaceDiffCount()">{{ getInterfaceDiffCount() }} diff</div>
      <button mat-icon-button class="collapse-btn" *ngIf="interfaceExpanded && selectedInterface?.length"
        (click)="toggleInterfacesCollapsed()"
        [attr.aria-label]="interfacesCollapsed ? 'Expand interfaces' : 'Collapse interfaces'">
        <mat-icon>{{ interfacesCollapsed ? 'unfold_more' : 'unfold_less' }}</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="interfaceExpanded; else interfaceCollapsedPrompt">
      <div class="section-hint" *ngIf="interfaceLoading">Loading interface differences…</div>
      <ng-container *ngIf="!interfaceLoading">
        <ng-container *ngIf="selectedInterface?.length; else interfaceEmpty">
          <div class="cards-col" *ngIf="!interfacesCollapsed; else interfacesCollapsedTpl">
            <div class="iface-card" *ngFor="let iface of getVisibleInterfaces(); let i = index; trackBy: trackByIndex">
              <div class="iface-fields">
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'interfaceName', iface)">
            <div class="field-label">Name</div>
            <div class="field-value">{{ iface.interfaceName }}</div>
          </div>
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'interfaceIP', iface)">
            <div class="field-label">IP</div>
            <div class="field-value">{{ iface.interfaceIP }}</div>
          </div>
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'interfaceSubnet', iface)">
            <div class="field-label">Subnet</div>
            <div class="field-value">{{ iface.interfaceSubnet }}</div>
          </div>
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'serialNumber', iface)">
            <div class="field-label">Serial #</div>
            <div class="field-value">{{ iface.serialNumber }}</div>
          </div>
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'recordDateTime', iface)">
            <div class="field-label">Record Date</div>
            <div class="field-value">{{ iface.recordDateTime }}</div>
          </div>
                <div class="field" [class.diff]="isInterfaceHighlighted(i,'retrievedDate', iface)">
            <div class="field-label">Retrieved</div>
            <div class="field-value">{{ iface.retrievedDate }}</div>
          </div>
              </div>
        </div>
            <button *ngIf="(selectedInterface?.length || 0) > (interfaceStart + interfaceWindowSize)" mat-stroked-button color="primary" class="load-more" (click)="loadMoreInterfaces()">Load More Interfaces</button>
          </div>
          <ng-template #interfacesCollapsedTpl>
            <div class="collapsed-note">Interfaces collapsed</div>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #interfaceCollapsedPrompt>
      <div class="placeholder small">
        <mat-icon>fact_check</mat-icon>
        <p *ngIf="interfaceDiffCount">Click the Interfaces card in the summary to load interface differences.</p>
        <p *ngIf="!interfaceDiffCount">No interface differences detected.</p>
      </div>
    </ng-template>
    <ng-template #interfaceEmpty>
      <div class="placeholder small">
        <mat-icon>fact_check</mat-icon>
        <p>No interface differences were returned by the compare service.</p>
      </div>
    </ng-template>
  </div>

  <div *ngIf="selectedInventory" class="section dns-section">
    <div class="section-header">
      <h3 class="section-title">DNS</h3>
      <div class="count-pill" [class.has-diff]="getDnsDiffCount()">{{ getDnsDiffCount() }} diff</div>
      <button mat-icon-button class="collapse-btn" *ngIf="dnsExpanded && selectedDns?.length"
        (click)="toggleDnsCollapsed()"
        [attr.aria-label]="dnsCollapsed ? 'Expand DNS' : 'Collapse DNS'">
        <mat-icon>{{ dnsCollapsed ? 'unfold_more' : 'unfold_less' }}</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="dnsExpanded; else dnsCollapsedPrompt">
      <div class="section-hint" *ngIf="dnsLoading">Loading DNS differences…</div>
      <ng-container *ngIf="!dnsLoading">
        <ng-container *ngIf="selectedDns?.length; else dnsEmpty">
          <div class="cards-col" *ngIf="!dnsCollapsed; else dnsCollapsedTpl">
            <div class="dns-card" *ngFor="let dns of getVisibleDns(); let i = index; trackBy: trackByIndex">
              <div class="dns-fields">
                <div class="field" [class.diff]="isDnsHighlighted(i,'dnsServer', dns)">
            <div class="field-label">Server</div>
            <div class="field-value">{{ dns.dnsServer }}</div>
          </div>
                <div class="field" [class.diff]="isDnsHighlighted(i,'serialNumber', dns)">
            <div class="field-label">Serial #</div>
            <div class="field-value">{{ dns.serialNumber }}</div>
          </div>
                <div class="field" [class.diff]="isDnsHighlighted(i,'recordDateTime', dns)">
            <div class="field-label">Record Date</div>
            <div class="field-value">{{ dns.recordDateTime }}</div>
          </div>
                <div class="field" [class.diff]="isDnsHighlighted(i,'retrievedDate', dns)">
            <div class="field-label">Retrieved</div>
            <div class="field-value">{{ dns.retrievedDate }}</div>
          </div>
              </div>
        </div>
            <button *ngIf="(selectedDns?.length || 0) > (dnsStart + dnsWindowSize)" mat-stroked-button color="primary" class="load-more" (click)="loadMoreDns()">Load More DNS</button>
          </div>
          <ng-template #dnsCollapsedTpl>
            <div class="collapsed-note">DNS entries collapsed</div>
          </ng-template>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #dnsCollapsedPrompt>
      <div class="placeholder small">
        <mat-icon>dns</mat-icon>
        <p *ngIf="dnsDiffCount">Click the DNS card in the summary to load DNS differences.</p>
        <p *ngIf="!dnsDiffCount">No DNS differences detected.</p>
      </div>
    </ng-template>
    <ng-template #dnsEmpty>
      <div class="placeholder small">
        <mat-icon>dns</mat-icon>
        <p>No DNS differences were returned by the compare service.</p>
      </div>
    </ng-template>
  </div>
</div>